import React, { useState, useEffect } from 'react'
import ImportBateryPage from 'src/pages/ReportsPages/ReportsBoard/SpareParts/ImportBateryPage'
import boardReportsService from 'src/services/boardReportsService'

const ImportBateryContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [total1, setTotal1] = useState([])
  const [gTotal1, setGTotal1] = useState([])
  const [total2, setTotal2] = useState([])


  const reloadImportsTotal = async () => {
    const [query1, gQuery1, query2] = await Promise.all([
      boardReportsService.getTotalImports('13', selectedDate.getFullYear(), 'dimension=BATERIA'),
      boardReportsService.getGTotalImports('4', selectedDate.getFullYear(), 'dimension=BATERIA'),
      boardReportsService.getTotalImports('14', selectedDate.getFullYear(), 'dimension=BATERIA'),
    ])
    setTotal1(query1 || [])
    setGTotal1(gQuery1 || [])
    setTotal2(query2 || [])
  }

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadImportsTotal()
  }, [])

  return (
    <ImportBateryPage
      total1={total1}
      total2={total2}
      gTotal1={gTotal1}
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
    />
  )
}

export default ImportBateryContainer
